module.exports = __webpack_public_path__ + "media/images/ios-add-b93260c2bfa8eed5d213c597a1c2b772.png";